const partners = Array.from({
  length: 12
}, (_, i) => ({
  id: i + 1,
  logo: '/assets/logo.png'
}));
export const PartnersSection = () => {
  return <section className="py-16 bg-muted/30">
      
    </section>;
};